import Api from "@/repository/ApiBase";
import {GetAttachment} from "@/repository/messagehub.dtos";
import {AxiosResponse} from "axios";

export class AttachmentApi extends Api {

    async getDownloadUrl(attachment: GetAttachment): Promise<AxiosResponse>{
        let result: AxiosResponse =  await this.Client.get('/attachment?id='+ attachment.id)
        return result
    }

}
